export default function pluralize(
  count: number,
  singular: string,
  plural = `${singular}ar`,
): string {
  if (count == 1) {
    return singular;
  }

  return plural;
}
